// Fechas en hora de Ciudad de México, sin importar el reloj ni la zona del aparato.
// ponytail: México quitó el horario de verano en 2022 → desfase fijo -06:00 en mxAt; si vuelve, calcularlo con Intl.
export const MX_TZ = "America/Mexico_City";

/** aaaa-mm-dd de un instante, en México. */
export const mxYmd = (d: Date = new Date()) =>
  d.toLocaleDateString("en-CA", { timeZone: MX_TZ });

/** aaaa-mm-dd + n días (aritmética de calendario, sin zonas). */
export const addDays = (ymd: string, n: number) => {
  const d = new Date(`${ymd}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

/** Hoy + n días en México (aaaa-mm-dd). */
export const mxDaysFromToday = (n: number) => addDays(mxYmd(), n);

/** Instante de un día y hora de México ("2026-09-26", "10:00"). */
export const mxAt = (ymd: string, hhmm = "00:00") =>
  new Date(`${ymd}T${hhmm}:00-06:00`);

/** Lunes (aaaa-mm-dd) de la semana de un instante, en México. */
export const mxMonday = (d: Date = new Date()) => {
  const ymd = mxYmd(d);
  const dow = new Date(`${ymd}T12:00:00Z`).getUTCDay();
  return addDays(ymd, -((dow + 6) % 7));
};
